import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import franchiseAdminAPI from "../../api/franchiseAdminAPI";
import usersApi from "../../api/userApi";

const AssignFranchiseModal = ({
  show,
  handleClose,
  selectedUser,
  onSuccess,
}) => {
  const [franchiseType, setFranchiseType] = useState("");
  const [franchiseList, setFranchiseList] = useState([]);
  const [selectedFranchise, setSelectedFranchise] = useState(null);

  // 🔄 Fetch franchises based on type
  useEffect(() => {
    if (!franchiseType) return;

    const fetchData = async () => {
      try {
        let res;
        if (franchiseType === "FA1") {
          res = await franchiseAdminAPI.getFranchises1List();
        } else {
          res = await franchiseAdminAPI.getFranchises2List();
        }
        setFranchiseList(res.data || []);
      } catch (err) {
        console.error("Error fetching franchises", err);
      }
    };

    fetchData();
  }, [franchiseType]);

  const handleSubmit = async () => {
    if (!selectedFranchise) {
      toast.error("Please select a franchise");
      return;
    }

    console.log("Assigning user", selectedUser.userEmail, "to franchise", selectedFranchise.referralCode);

    try {
      await usersApi.updateReferralCode(
        selectedUser.userId,
        selectedFranchise.referralCode,
      );
      toast.success("Assigned successfully");
      handleClose();
      onSuccess();
    } catch (err) {
      console.error(err);
      toast.error("Assignment failed");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Title>Assign Franchise for {selectedUser?.userName}</Modal.Title>
      {/* ToastContainer for this component */}
      <ToastContainer position="top-right" autoClose={3000} />

      <Modal.Body>
        {/* Select Type */}
        <Form.Group>
          <Form.Label>Franchise Type</Form.Label>
          <Form.Select
            value={franchiseType}
            onChange={(e) => {
              setFranchiseType(e.target.value);
              setSelectedFranchise(null);
            }}
          >
            <option value="">Select</option>
            <option value="FA1">Franchise 1</option>
            <option value="FA2">Franchise 2</option>
          </Form.Select>
        </Form.Group>

        {/* Franchise Dropdown */}
        {franchiseType && (
          <Form.Group className="mt-3">
            <Form.Label>Select Franchise</Form.Label>
            <Form.Select
              onChange={(e) => {
                const selected = franchiseList.find(
                  (f) => f.id === parseInt(e.target.value),
                );
                setSelectedFranchise(selected);
              }}
            >
              <option value="">Select</option>
              {franchiseList.map((f) => (
                <option key={f.id} value={f.id}>
                  {f.organization} - {f.location}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}

        {/* Auto-filled */}
        {selectedFranchise && (
          <div className="mt-3">
            <strong>Managed By:</strong> {selectedFranchise.email}
            <br />
            <strong>Referral Code:</strong> {selectedFranchise.referralCode}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Assign
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignFranchiseModal;
